import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';

import { Client } from '../../models';
import { Stylist } from '../../models';
import { ClientService } from '../../services/client.service';
import { UserService } from '../../services/user.service';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';

// import 'rxjs/add/operator/debounceTime';
// import 'rxjs/add/operator/switchMap';

import { debounceTime } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

export interface IStylistPickerInit { success: boolean, stylist: Stylist};
@Component({
  selector: 'app-universal-search',
  templateUrl: './universal-search.component.html',
  styleUrls: ['./universal-search.component.scss'],
})
export class UniversalSearchComponent implements OnInit {

  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public client: Client;

  public stylist: Stylist;

  public isLoadingStylists: boolean;

  public errorOccurredWhileLoadingStylists: boolean;

  public readOnlyStylistPicker: boolean;

  // @ViewChild('univerSearchBar') univerSearchBar: Searchbar;

  // public isLoading: boolean;

  // public errorOccurred: boolean;

  // public searchTerm: string;

  // public clientList: List<Client>;

  // public clientSearchHistory: List<Client>;

  // public searchField: FormControl;

  // public searchForm: FormGroup;

  constructor(private alertCtrl: AlertController,
              private clientService: ClientService,
              private userService: UserService,
              private loadingCtrl: LoadingController,
              private modalCtrl: ModalController,
              private formBuilder: UntypedFormBuilder,
              private changeDetectorRef: ChangeDetectorRef) {
    // this.searchTerm = '';
    // this.clientList = List([]);
    // this.clientSearchHistory = List([]);
    // this.errorOccurred = false;
    // this.searchField = new FormControl();
    // this.searchForm = this.formBuilder.group({
    //   searchField: this.searchField
    // });

    this.isLoadingStylists = true;
    this.errorOccurredWhileLoadingStylists = false;
    if (this.userService.getUser().isAdministrator() ||
      this.userService.getUser().getViewAllCalendars() === 1 ||
      this.userService.getUser().getViewAllClients() === 1) {
      this.readOnlyStylistPicker = false;
    } else {
      this.readOnlyStylistPicker = true;
    }
  }

  public ngOnInit() {
    // this.clientSearchHistory = this.clientService.getSearchHistory();
    // setTimeout(() => {
    //   this.univerSearchBar.setFocus();
    // },150);

    // this.searchField.valueChanges
    //   .pipe(
    //     debounceTime(400)
    //   )
    //   .subscribe((term: string) => {
    //     this.isLoading = true;
    //     this.errorOccurred = false;
    //     this.changeDetectorRef.markForCheck();
    //     this.clientService.searchClients(term, this.userService.getUser(), 'true')
    //       .subscribe((searchResult: List<Client>) => {
    //         this.clientList = searchResult;
    //         this.isLoading = false;
    //         this.changeDetectorRef.markForCheck();
    //       },
    //       (error) => {
    //         this.isLoading = false;
    //         this.errorOccurred = true;
    //         this.changeDetectorRef.markForCheck();
    //       });
    //   },
    //   (error) => {
    //     this.isLoading = false;
    //     this.errorOccurred = true;
    //     this.changeDetectorRef.markForCheck();
    //   });

  }

  public dismiss() {
    this.modalCtrl.dismiss();
  }

  public onClientSelect(client: Client) {
    this.client = client;
    this.modalCtrl.dismiss(client);
  }

  public onStylistPickerInit($event: IStylistPickerInit) {
    if ($event.success) {
      this.stylist = $event.stylist;
      this.isLoadingStylists = false;
    } else {
      this.isLoadingStylists = false;
      this.errorOccurredWhileLoadingStylists = true;
    }
  }

  public onRetry() {
    this.isLoadingStylists = true;
    this.errorOccurredWhileLoadingStylists = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public onStylistSelectChange($event: Stylist) {
    this.stylist = $event;
  }


}
